<template>
  <Card no-padding class="keyword-planner-result">
    <header class="keyword-planner-result__header">
      <div class="keyword-planner-result__header-form">
        <KeywordPlannerResultSearchForm
          :keywords="selectedKeywords"
          @submit="emitKeywordsFormSubmit"
        />
      </div>

      <div class="keyword-planner-result__header-column-settings">
        <KeywordColumnSettings
          :visible-columns="columns.visible"
          :hidden-columns="columns.hidden"
          :locked-columns="columns.locked"
          @update:visible-columns="setVisibleColumns"
          @update:hidden-columns="setHiddentColumns"
        />
      </div>
    </header>

    <Transition name="fade">
      <KeywordPlannerResultActionRow
        v-model="showActionRow"
        :selected-suggested-keywords="selectedRows"
        @changeShow="clearSelection"
      />
    </Transition>

    <div>
      <KeywordPlannerResultList
        v-loading="isLoading"
        :total="total"
        :columns="shownColumns"
        :data="data"
        :selection.sync="selectedRows"
        :clear-selection-controller="clearSelectionController"
        @update:selection="handleChangeSelectionToShowActionRow"
        @change-current="emitChangeCurrentAndClearSelection"
        @change-size="emitChangeSizeAndClearSelection"
      />
    </div>
  </Card>
</template>

<script>
import createController from '@/utils/controller';
import KeywordPlannerResultSearchForm from './KeywordPlannerResultSearchForm';
import KeywordPlannerResultList from './KeywordPlannerResultList';
import KeywordPlannerResultActionRow from './KeywordPlannerResultActionRow';
import KeywordColumnSettings from '../../common/keyword/KeywordColumnSettings';

import Card from '@@/common/Card';

import keywordPlannerColumnStorage from './common/utils/KeywordPlannerColumnStorage';
import { lockedColumns } from './common/columns';

const clearSelectionController = createController('clearSelection');

export default {
  name: 'KeywordPlannerResult',
  components: {
    Card,
    KeywordPlannerResultSearchForm,
    KeywordPlannerResultList,
    KeywordPlannerResultActionRow,
    KeywordColumnSettings,
  },
  props: {
    selectedKeywords: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      columns: {
        visible: keywordPlannerColumnStorage.getVisibleColumns(),
        hidden: keywordPlannerColumnStorage.getHiddenColumns(),
        locked: lockedColumns,
      },
      showActionRow: false,
      selectedRows: [],
    };
  },
  computed: {
    clearSelectionController() {
      return clearSelectionController;
    },
    shownColumns() {
      return [...this.columns.locked, ...this.columns.visible];
    },
  },
  methods: {
    setVisibleColumns(cols) {
      this.columns.visible = cols;
      keywordPlannerColumnStorage.setVisibleColumns(cols);
    },
    setHiddentColumns(cols) {
      this.columns.hidden = cols;
    },
    emitChangeCurrentAndClearSelection(page) {
      this.clearSelection();

      this.$emit('change-current', page);
    },
    emitChangeSizeAndClearSelection(size) {
      this.clearSelection();

      this.$emit('change-size', size);
    },
    emitKeywordsFormSubmit(data) {
      this.$emit('submit-keywords-form', data);
    },
    handleChangeSelectionToShowActionRow(selection) {
      if (selection.length > 0) {
        this.handleActionRow(true);
        return;
      }
      this.handleActionRow(false);
    },
    handleActionRow(value) {
      this.showActionRow = value;
    },
    clearSelection() {
      clearSelectionController.clearSelection();
    },
  },
};
</script>

<style lang="scss">
.keyword-planner-result {
  &__header {
    display: flex;
    align-items: center;

    padding: $global-padding * 1.25;

    box-shadow: 0 1px 0 #dfdfdf, 0 5px 10px rgba(192, 196, 204, 0.24);
    position: relative;

    &-form {
      flex-grow: 1;
      flex-basis: 0;
    }
  }
}
</style>
